<template>
    <div id="SetPhone">
        <nav-bar>
            <div slot="left" v-if="this.loginFrom.telephone != ''">
                <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
            </div>
            <div slot="title" style="font-weight: 800; font-size: 15px;  letter-spacing:2px;">{{title}}</div>
        </nav-bar>
        <div style="height: 50px; width: 100%;"></div>
        <van-form @submit="onSubmit">
            <div style="margin: 10px"><span style="font-size: 10px;">{{ titleHint }}</span></div>
            <van-field label="国家和地区" value="中国" readonly />
            <van-field style="border-top-right-radius: 10px; border-top-left-radius: 10px;"
                       v-model="loginFrom.telephone"
                       name="手机号码"
                       label="手机号码"
                       placeholder="手机号码"
            />

            <van-field
                    v-model="loginFrom.authCode"
                    type="code"
                    name="短信验证码"
                    label="短信验证码"
                    placeholder=""
                    :rules="[{ required: true, message: '请填写手机短信验证码' }]"
            >
                <van-button slot="button" native-type="button" size="small" type="primary" @click="getcode" :disabled="disabled" >
                    发送验证码
                    <span v-if="this.num != 60 ">
                        ({{num}})
                    </span>
                </van-button>
            </van-field>


            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">提交</van-button>
            </div>

        </van-form>
    </div>
</template>

<script>

    import NavBar from "@/components/common/navbar/NavBar";
    import { Icon, Button,Form,Field,Toast  } from 'vant'
    import {getAccounts,setPhone} from "../../network/mine/account"
    import {getCodeTelephone} from "../../network/login/login";

    export default {
        name: "SetPhone",
        components: {
            NavBar:NavBar,
            [Icon.name]: Icon,
            [Button.name]: Button,
            [Form.name]: Form,
            [Field.name]: Field,
            [Toast.name]: Toast,
        },
        data(){
          return{
              title:"设置手机号码",
              titleHint:"请输入你要绑定的手机号码",
              loginFrom:{
                  telephone:'',
                  authCode:''
              },
              disabled:false,
              num:60
          }
        },
        methods:{
            goBack(){
                this.$router.back(-1);
            },
            onSubmit(){
                if (this.loginFrom.telephone == ''){
                    Toast('请输入手机号码!')
                    return false;
                }
                if(this.loginFrom.telephone.length != 11){
                    Toast('请输入正确的手机号码!')
                    return false;
                }
                setPhone(this.loginFrom.telephone, this.loginFrom.authCode).then((res)=>{
                    if (res.code == 200){
                        Toast.success("绑定成功,等待跳转");
                        setTimeout(() => {
                            Toast.clear()
                            this.$router.push({path: "/home"})
                        }, 1000)


                    }
                },error => {
                    Toast.fail('输入的手机号码有误或者已经注册过');
                })
            },
            disabledfun(){
                this.timer = setInterval(this.addnum, 1000);
            },
            addnum(){//设置计时器
                if (this.num == 0){
                    this.num = 60;
                    this.disabled = false;
                    clearInterval(this.timer);
                    return true;
                }
                this.num--;
            },
            getcode(){ //获取验证码
                if (this.loginFrom.telephone == ''){
                    Toast('请输入手机号码!')
                    return false;
                }
                if(this.loginFrom.telephone.length != 11){
                    Toast('请输入正确的手机号码!')
                    return false;
                }
                getCodeTelephone(this.loginFrom.telephone).then((res)=>{
                    //设置禁止按钮
                    this.disabled = true;
                    Toast('验证码发送成功')
                    this.disabledfun()
                })
            },
        },
        created() {
            getAccounts().then((res)=>{
                if (res.code == 200){
                    if (res.data.phone.length == 11 && res.data.phone != 0){
                        this.loginFrom.telephone = res.data.phone;
                        this.title = "输入更改的手机号码"
                    }else {
                        this.title = "输入绑定手机号"
                    }
                }
            })
        }
    }
</script>

<style scoped>
    #SetPhone{
        background: #f8f6f7;
        /*height: 800px;*/
        width: 100%;
    }
</style>
